import { AbilityBuilder } from '@casl/ability'

export function defineAbilitiesFor(user) {
  const role = user.role
  const { rules, can, cannot } = AbilityBuilder.extract()

  if (role === 'Administrator') {
    can('manage', 'all')
  }

  if (role === 'Support') {
    can(['edit'], 'Administrator', { id: user.id })
    can(['list', 'read'], 'Administrator')
    can(['list', 'read'], 'Campaign')
    can(['list', 'read', 'edit'], 'Candidate')
    can(['list', 'read'], 'Client')
    can(['list', 'read'], 'Discipline')
    can(['list'], 'DocumentBundle')
    can(['list', 'read'], 'Eligibility')
    can(['list', 'read', 'edit', 'delete'], 'Experience')
    can(['list', 'read'], 'ExperienceOrganization')
    can(['list', 'read', 'create'], 'Flag')
    can(['list', 'read'], 'Institution')
    can(['list'], 'Invite')
    can(['list', 'read'], 'Opportunity')
    can(['list', 'read', 'regenerate'], 'OpportunityApplication')
    can(['list', 'read'], 'Organization')
    can(['list', 'read', 'edit', 'regenerate'], 'Profile')
    can(['list', 'read'], 'Qualification')
    can(['list', 'read'], 'QualificationType')
    can(['list', 'read', 'edit', 'delete', 'verify'], 'ProfileQualification')
    can(['list', 'read'], 'QualificationComponent')
    can(['list'], 'Referral')
    can(['list', 'read'], 'Supervisor')
    can(['list', 'read'], 'HourlyAnalytic')
    can(['list', 'read'], 'AdminAnalytic')
  }

  if (role === 'Support Manager') {
    can(['edit'], 'Administrator', { id: user.id })
    can(['list', 'read'], 'Administrator')
    can(['read'], 'Analytics')
    can(['edit'], 'Answer')
    can(['edit'], 'AnswerSet')
    can(['list', 'read'], 'Attachment')
    can(['list', 'read', 'create', 'edit'], 'Campaign')
    can(['list', 'read', 'edit'], 'Candidate')
    can(['list', 'read', 'create', 'edit'], 'Client')
    can(['list', 'read'], 'Discipline')
    can(['list'], 'DocumentBundle')
    can(['list', 'read', 'reset'], 'Eligibility')
    can(['list', 'read', 'create', 'edit', 'delete'], 'Experience')
    can(['list', 'read', 'create', 'edit'], 'ExperienceOrganization')
    can(['list', 'read', 'create', 'delete'], 'Flag')
    can(['list', 'read', 'create', 'edit'], 'Institution')
    can(['list', 'create'], 'Invite')
    can(['list'], 'Job')
    can(['list', 'read', 'create'], 'Note')
    can(['list', 'read', 'create', 'edit', 'ats', 'batch', 'prioritize'], 'Opportunity')
    can(['list', 'read', 'edit', 'regenerate'], 'OpportunityApplication')
    can(['list', 'read', 'create', 'edit'], 'Organization')
    can(['list', 'read', 'edit', 'regenerate'], 'Profile')
    can(['list', 'read', 'create', 'edit'], 'Qualification')
    can(['list', 'read'], 'QualificationType')
    can(['list', 'read', 'create', 'edit', 'delete', 'verify'], 'ProfileQualification')
    can(['list', 'read', 'create', 'edit'], 'QualificationComponent')
    can(['list', 'create'], 'Referral')
    can(['list'], 'Report')
    can(['list', 'read', 'create', 'edit'], 'Supervisor')
    can(['list', 'read'], 'HourlyAnalytic')
    can(['list', 'read'], 'AdminAnalytic')
  }

  if (role === 'Ambassador') {
    can(['read'], 'Eligibility')
    can(['list'], 'Opportunity')
  }

  return rules
}

function subjectName(subject) {
  return !subject || typeof subject === 'string' ? subject : subject.$type
}
export default AbilityBuilder.define({ subjectName }, can => {})
